import React from "react";
import { makeStyles } from "@material-ui/core";

import Next from "./assets/next.svg";

export default function PaginatorArrow({ back, disabled }) {
  const classes = useStyle({
    back,
    disabled,
  });

  return <Next className={classes.arrow} />;
}

const useStyle = makeStyles(() => ({
  arrow: {
    transform: (props) => (props.back ? "rotate(180deg)" : "none"),
    opacity: (props) => (props.disabled ? 0.3 : 1),
  },
}));
